import { useEffect, useState } from "react";

export type TTokenService = {
	token: string | null;
	listeners: (() => void)[];
	addEventListener: (cb: () => void) => void;
	removeEventListener: (cb: () => void) => void;
	clearToken: () => void;
	saveToken: (newToken: string) => void;
	emitChanges: () => void;
};

export const TokenService: TTokenService = {
	token: null,
	listeners: [],

	addEventListener(cb) {
		this.listeners = this.listeners.filter((listener) => listener !== cb);
		this.listeners.push(cb);
	},

	saveToken(newToken) {
		this.token = newToken;
		localStorage.setItem("token", newToken);
		this.emitChanges();
	},

	clearToken() {
		this.token = null;
		localStorage.removeItem("token");
		this.emitChanges();
	},

	emitChanges() {
		for (const listener of this.listeners) {
			listener();
		}
	},

	removeEventListener(cb) {
		this.listeners = this.listeners.filter((listener) => listener !== cb);
	},
};

export function useToken() {
	const [token, setToken] = useState(localStorage.getItem("token"));

	useEffect(() => {
		const updateToken = () => {
			setToken(TokenService.token);
		};

		TokenService.addEventListener(updateToken);

		return () => {
			TokenService.removeEventListener(updateToken);
		};
	}, []);

	return { token };
}
